/**
 * アプリケーションエントリーポイント
 * @author nabla2.metamodel.generator
 */
import 'rxjs/Rx'
import 'whatwg-fetch'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app.module'
import { ENV } from '../config/config.dev';
import { ENVManager } from '@ar2/common';
import { enableProdMode } from '@angular/core';

if (true) {
	  enableProdMode();
}
ENVManager.SET(ENV);

platformBrowserDynamic().bootstrapModule(AppModule)


// WEBPACK FOOTER //
// ./src/app/main.ts